export enum CARRIER_PERMISSIONS {
  CARRIER_VIEW = 'CARRIER_VIEW',
  CARRIER_WRITE = 'CARRIER_WRITE',
}

export enum DRIVER_PERMISSIONS {
  DRIVER_VIEW = 'CARRIER_DRIVERSVIEW',
  DRIVER_WRITE = 'CARRIER_DRIVERSWRITE',
}
